// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"fcd52ed8","363":"bb7b865f","453":"da930f90","594":"f224940d","661":"c0fe1441","665":"8dbcf7f0","681":"9439ded5","842":"067331e2","988":"5731522d"}[chunkId] + ".chunk.js";
};